<template>
<div>
  <span class="hidden-sm-and-down">
    <v-data-table :headers="headers" hide-actions :items="sellOrders" class="elevation-0" style="overflow: auto; height:87vh;">
    <template v-slot:items="props">
      
      <v-tooltip top>
              <template v-slot:activator="{ on }">
                <tr @click="handleClickAsk(props.item.askPrice,props.item.askAmount,props.item.askTotal)" class="red--text" >
                  <td class="text-xs-center font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.askPrice) }}</td>
                  <td class="text-xs-center font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:7}).format(props.item.askAmount) }}</td>
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:1}).format(props.item.askTotal) }}</td>
                </tr>
              </template>
              <span>{{price}} </span>
      </v-tooltip>

    </template>
  </v-data-table>
  </span>
  
  <span class="hidden-md-and-up">
    <v-data-table :headers="headers" hide-actions :items="sellOrders" class="elevation-0" style="overflow: auto; height:50vh;">
    <template v-slot:items="props">
      
                <tr @click="handleClickAsk(props.item.askPrice,props.item.askAmount,props.item.askTotal)" class=" red--text font-weight-bold">
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.askPrice) }}</td>
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:7}).format(props.item.askAmount)}}</td>
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:1}).format(props.item.askTotal) }}</td>
                </tr>
            
    </template>
  </v-data-table>

  </span>
</div>
  
</template>

<script>
import { mapActions,mapState } from "vuex";

export default {
  props: {
    asset: {
      type: String,
    },
    currency:{
      type:String
    },
     second:{
      type:String
    }
  },
  data() {
    return {
      headers: [
        { text: "Prix", align: "left", sortable: false },
        { text: "Montant", sortable: false },
        { text: "Total",sortable: false }
      ],
      price:null,
    };
  },
mounted () {
      this.someAction()
},
computed: {
    ...mapState({
      sellOrders(state,getters) {
        return getters["order/"+this.currency+this.second+"_sellOrders" ]
    }
    }),
    
  },
  methods:{
    handleClickAsk(askPrice, askAmount, askTotal){
      this.$root.$emit('clickAsk',askPrice, askAmount, askTotal)
    },
     ...mapActions({
        someAction (dispatch) {
        return dispatch("order/bind_"+ this.currency+this.second+"_sellOrders")
      }
       })
  } 
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: red; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>
 
<style>
  tr td {
  font-family: "Titillium Web", sans-serif;
}
</style>